import { render, staticRenderFns } from "./FlyingView.vue?vue&type=template&id=1b40287d"
import script from "./FlyingView.vue?vue&type=script&lang=js"
export * from "./FlyingView.vue?vue&type=script&lang=js"
import style0 from "./FlyingView.vue?vue&type=style&index=0&id=1b40287d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports